import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/Home.vue";
import { isSessionValid } from "../config.js"; 


const routes = [
  {
    path: "/",
    meta: {
      title: "HOME",
    },
    name: "Home",
    component: HomeView,
  },
 
   {
    path: "/change-password",
    meta: {
      title: "CHANGE PASSWORD ",
    },
    component: () => import("../views/ChangePasswordView.vue"),
  },
  //ROTAS COM ACESSO RESTRITO
 
  {
    path: "/resultadoshistopatologico",
    meta: {
      title: "Interpretação de Análise Histopatológico  ",
    },
    component: () => import("../views/ResultadosHistopatologicoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosPSA",
    meta: {
      title: "Interpretação do PSA  ",
    },
    component: () => import("../views/PSADiagnosticoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/diagtoqueretal",
    meta: {
      title: "Interpretação de Toque Retal  ",
    },
    component: () => import("../views/DiagnosticoTRView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/fixacao",
    meta: {
      title: "FIXAÇÃ0",
    },
    component: () => import("../views/FixacaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  {
    path: "/examemacroscopica",
    meta: {
      title: "EXAME MACROSCÓPICA",
    },
    component: () => import("../views/ExameMacroscopicaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/desidratacao",
    meta: {
      title: "DESITDRATAÇÃO",
    },
    component: () => import("../views/DesidratacaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/inclusao",
    meta: {
      title: "INCLUSÃO",
    },
    component: () => import("../views/InclusaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/cortes",
    meta: {
      title: "CORTES/ Micrótomo",
    },
    component: () => import("../views/CortesView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/h&e",
    meta: {
      title: "Hematoxilina e Eosina",
    },
    component: () => import("../views/HeEView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/ihq",
    meta: {
      title: "IMUNOHISTOQUÍMICA",
    },
    component: () => import("../views/IHQView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
   {
    path: "/montagem",
    meta: {
      title: "MONTAGEM",
    },
    component: () => import("../views/MontagemView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/microscopica",
    meta: {
      title: "Análise Microscópica",
    },
    component: () => import("../views/AnaliseMicroscopicaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  {
    path: "/lab3d",
    meta: {
      title: "LAB 3D",
    },
    component: () => import("../views/Lab3dView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/salavirtual",
    meta: {
      title: "SALA DE AULA VIRTUAL",
    },
    component: () => import("../views/SaladeAulaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/salavirtualfitsi",
    meta: {
      title: "SALA DE FITSI",
    },
    component: () => import("../views/SaladeAulaJitsiView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosh&e",
    meta: {
      title: "DIAGNÓSTICOS H&E",
    },
    component: () => import("../views/DiagnosticosHeEView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosihq",
    meta: {
      title: "DIAGNÓSTICOS IHQ",
    },
    component: () => import("../views/DiagnosticosIHQView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
   {
    path: "/guidelines",
    meta: {
      title: "GUIDELINES CLÍNICOS",
    },
    component: () => import("../views/GuidelinesView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  //sem restricao

  
  {
    path: "/eventview/:id",
    meta: {
      title: "EVENTOS",
    },
    name: "eventview",
    component: () => import("../views/EventView.vue"),
  },
   
  {
    path: "/noticias",
    meta: {
      title: "NOTÍCIAS",
    },
    name: "NoticiasView",
    component: () => import("../views/NoticiasView.vue"),
  },
  {
    path: "/eventos",
    meta: {
      title: "EVENTOS",
    },
    name: "EventosView",
    component: () => import("../views/EventosView.vue"),
  },
  {
    path: "/galerias",
    meta: {
      title: "GALERIAS",
    },
    name: "GaleriaView",
    component: () => import("../views/GaleriaView.vue"),
  },
  {
    path: "/videos",
    meta: {
      title: "VIDEOS ",
    },
    name: "VideosView",
    component: () => import("../views/VideosView.vue"),
  },
  {
    path: "/forum",
    meta: {
      title: "FORÚM ",
    },
    name: "ForumView",
    component: () => import("../views/ForumView.vue"),
  },
  {
    path: "/repositorio",
    meta: {
      title: "REPOSIT]ORIO CIENTÍFICO ",
    },
    name: "RepositorioView",
    component: () => import("../views/RepositorioView.vue"),
  },

  {
    path: "/equipa",
    meta: {
      title: "EQUIPA",
    },
    name: "EquipaView",
    component: () => import("../views/EquipaView.vue"),
  },

  {
    path: "/projeto",
    meta: {
      title: "PROJETO",
    },
    name: "ProjetoView",
    component: () => import("../views/ProjetoView.vue"),
  },

  {
    path: "/saudemasculina",
    meta: {
      title: "SAÚDE MASCULINA",
    },
    name: "SaudeMasculinaView",
    component: () => import("../views/SaudeMasculinaView.vue"),
  },
  {
    path: "/cancro",
    meta: {
      title: "CANCRO ",
    },
    name: "CancroView",
    component: () => import("../views/CancroView.vue"),
  },
   {
    path: "/tratamentocancro",
    meta: {
      title: "TRATAMENTO CANCRO ",
    },
    name: "TratamentoCancro",
    component: () => import("../views/TratamentoCancroView.vue"),
  },
  {
    path: "/hiperplazia",
    meta: {
      title: "HIPERPLAZIA ",
    },
    name: "HiperplaziaView",
    component: () => import("../views/HiperplaziaView.vue"),
  },
  {
    path: "/prostatite",
    meta: {
      title: "PROSTATITE ",
    },
    name: "ProstatiteView",
    component: () => import("../views/ProstatiteView.vue"),
  },
  {
    path: "/analisesclinicas",
    meta: {
      title: "ANÁLISES CLÍNICAS ",
    },
    component: () => import("../views/AnalisesClinicasView.vue"),
  },

  {
    path: "/toqueretal",
    meta: {
      title: "TOQUE RETAL ",
    },
    component: () => import("../views/ToqueRetalView.vue"),
  },
  {
    path: "/exameimagens",
    meta: {
      title: "EXAME IMAGENS ",
    },
    component: () => import("../views/ExameImagensView.vue"),
  },
  {
    path: "/examesanguineo",
    meta: {
      title: "EXAME SANGUINEO ",
    },
    component: () => import("../views/ExameSanguineoView.vue"),
  },
  {
    path: "/examehistopatologico",
    meta: {
      title: "EXAME HISTOPATOLÓGICO ",
    },
    component: () => import("../views/ExameHistopatologicoView.vue"),
  },
  {
    path: "/examelipidomica",
    meta: {
      title: "EXAME LIPIDÓMICA ",
    },
    component: () => import("../views/ExameLipidomicaView.vue"),
  },

  // outras rotas...
  /*beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next('/'); // redireciona para home se não estiver logado
    },*/
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


// Hook para atualizar o título dinâmico
router.beforeEach((to, from, next) => {
  const siteName = "INCUBATOR";
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - ${siteName}`;
  } else {
    document.title = siteName;
  }
  next();
});



export default router;

